import { render, staticRenderFns } from "./documentsDetail.vue?vue&type=template&id=22ed18a6&scoped=true"
import script from "./documentsDetail.vue?vue&type=script&lang=js"
export * from "./documentsDetail.vue?vue&type=script&lang=js"
import style0 from "./documentsDetail.vue?vue&type=style&index=0&id=22ed18a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed18a6",
  null
  
)

export default component.exports